import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { StenaButtonComponent } from '@app-monorepo/shared/ui/stena-components';
import { environment } from '../../../environments/environment';

@Component({
  standalone: true,
  selector: 'app-access-denied-page',
  templateUrl: './access-denied-page.component.html',
  styleUrl: './access-denied-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [StenaButtonComponent],
})
export class AccessDeniedPageComponent {
  private readonly msal = inject(MsalService);

  protected readonly contact = environment.contact;

  protected readonly username =
    this.msal.instance.getActiveAccount()?.username ??
    this.msal.instance.getAllAccounts()[0]?.username ??
    '';

  onSignOut() {
    this.msal.logoutRedirect({
      postLogoutRedirectUri: environment.auth.postLogoutRedirectUri,
    });
  }
}
